import { EnvironmentProviders, Provider } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { provideZoneChangeDetection } from '@angular/core';
import { authInterceptor } from './auth.interceptor';
import { errorHandlerInterceptor } from './error-handler.interceptor';
import { AUTH_SERVICE } from './auth-base.service';
import { AuthService } from './auth.service';

export const sharedProviders: (Provider | EnvironmentProviders)[] = [
  provideZoneChangeDetection({ eventCoalescing: true }),
  provideHttpClient(withInterceptors([errorHandlerInterceptor, authInterceptor])),
  { provide: AUTH_SERVICE, useExisting: AuthService },
  provideAnimationsAsync(),
  {
    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
    useValue: { appearance: 'outline', floatLabel: 'always', subscriptSizing: 'dynamic' },
  },
  {
    provide: MAT_SELECT_CONFIG,
    useValue: { appearance: 'outline', floatLabel: 'always' },
  },
  {
    provide: MAT_DIALOG_DEFAULT_OPTIONS,
    useValue: { maxWidth: '95vw', hasBackdrop: true },
  },
];
